import { roleValidate } from "../../application/dtos/role_validate";

export class roleEntity {
    constructor({ id, name, is_for_clients, permissions}){
        this.id = id;
        this.name = name;
        this.is_for_clients = is_for_clients;
        this.permissions = permissions;
    }

    isValid() {
        return roleValidate(this);
    }
}